import { generateUniqueId } from "../../../../common/generateUniqueId";
import { Logics } from "../../../logics/logics/Logics";
import Variable, { variableFromLogics } from "./Variable";

export interface Device {
	id: string;
	label: string;
	name: string;
	address?: string;
	size: number;

	inputs: Input[];
	outputs: Output[];

	configs: Record<string, Config[]>;
}

export interface Input {
	id: number;
	name: string;
	[key: string]: string | boolean | number;
}

export interface Output {
	id: number;
	name: string;
	[key: string]: string | boolean | number;
}

export interface Config {
	label: string;
	details?: string;
	variables: Record<string, Variable>;
}

export default Device;

export function createDevice(name: string, logics: Logics): Device {
	const logicsDevice = logics.device[name];

	const device: Device = {
		id: generateUniqueId("device"),
		name,
		label: name,
		size: logicsDevice.size,
		inputs: Object.entries(logicsDevice.input).map(([name, input]) => {
			const { id, ...variables } = input;

			return {
				id: input.id,
				name,
				...Object.entries(variables).reduce((init, [key, variable]) => {
					return {
						...init,
						[key]: Array.isArray(variable) ? variable[0] : variable,
					};
				}, {}),
			};
		}),
		outputs: Object.entries(logicsDevice.output).map(([name, output]) => {
			const { id, ...variables } = output;

			return {
				id: output.id,
				name,
				...Object.entries(variables).reduce((init, [key, variable]) => {
					return {
						...init,
						[key]: Array.isArray(variable) ? variable[0] : variable,
					};
				}, {}),
			};
		}),
		configs: Object.fromEntries(
			Object.entries(logicsDevice.config).map(([name, config]) => {
				const configConfig = logics.config[name];

				const configItems: Config[] = config.map((item) => {
					const details = item.details;

					const variables = Object.fromEntries(
						configConfig.variables.map((logicsVariable) => {
							const variable = variableFromLogics(logicsVariable);

							const value = item.properties?.[logicsVariable.name];
							if (value !== undefined) {
								variable.content.value = value;
							}

							return [variable.label, variable];
						}),
					);

					return {
						label: configConfig.label,
						details,
						variables,
					};
				});

				return [name, configItems];
			}),
		),
	};

	return device;
}
